import { DropdownModel } from '@shared/models/dropdown-model.model';
import { Expose } from 'class-transformer';

export class AVLGroup extends DropdownModel {
  @Expose() id: number;
  @Expose() attributes?: any;
  @Expose() groupId?: number;
  @Expose() name?: string;

  constructor() {
    super();
  }

  get dropDownDisplayName(): string {
    return this.name;
  }
  get dropDownValue(): object {
    return this;
  }
}
